import blog_image_1 from "../assets/blog_img_1.png";
import blog_image_2 from "../assets/blog_img_2.png";
import blog_image_3 from "../assets/blog_img_3.png";

const blogs_data = [
  {
    title:
      "How to Build a Winning Fleet Safety Program in 2025 - Fleetblox Blo...",
    date: "12 May 2025",
    image: blog_image_1,
    link: "https://blog.fleetblox.com/2024/05/26/how-to-build-a-winning-fleet-safety",
  },
  {
    title:
      "Proactive Maintenance and Diagnostics for Smarter Fleet Operations ...",
    date: "17 Jan 2024",
    image: blog_image_3,
    link: "https://blog.fleetblox.com/2024/05/24/maintenance-and-diagnostics",
  },
  {
    title:
      "Fleet Maintenance Management: Solving Today’s Challenges with Sma...",
    date: "23 Nov 2023",
    image: blog_image_2,
    link: "https://blog.fleetblox.com/2024/05/29/fleet-maintenance-management-solving",
  },
];
const faqData = {
  faq: [
    {
      question: "What is Drivestamp?",
      answer:
        "Drivestamp is a simple and powerful peer-to-peer vehicle handover solution that records and verifies vehicle condition before and after every drive.It creates a tamper-proof, audit-ready digital stamp that protects both vehicle owners and drivers by eliminating disputes over damage responsibility.",
    },
    {
      question: "How does Drivestamp work?",
      answer:
        "Drivestamp works in three easy steps. First, enter vehicle details including vehicle make, model, and year. both parties complete a guided digital flow of the vehicle’s through a secure browser link. The system generates a digital Drive Stamp with before-and-after comparison, creating a clear, verifiable record of the vehicle’s condition for that drive usage.",
    },
    {
      question: "What are the benefits of using Drivestamp?",
      answer:
        "Drivestamp offers several key benefits: improved asset protection through continuous visibility of vehicle condition, fewer disputes with clear before-and-after evidence, faster claims resolution with structured and verifiable records, transparent charge justification for any damages, and instant access to pre-post drive reports. It eliminates manual inspection paperwork and provides accountability for every handover.",
    },
    {
      question:
        "Can I manually add or edit damages if the AI misses something?",
      answer:
        "Yes. During the review phase of the stamp flow, you can manually add, edit, or remove damages before you generate the final stamp. This applies to both origin and impact stamp and allows you to generate more accurate and customizable vehicle stamp",
    },
    {
      question: "Can I recapture or edit result?",
      answer:
        "Yes, as long as the final stamp has not been generated. You may recapture or edit before final submission.",
    },
    {
      question:
        "What is the difference between a origin stamp and a impact stamp?",
      answer:
        "A origin stamp scan and recording the vehicle’s condition at the start of the handover before the drives. A impact stamp records the vehicle’s condition at the end of the drive. It includes all previously recorded origin conditions for reference and highlights any new damages that occurred during the custody period",
    },
    {
      question: "Is the AI always correct?",
      answer:
        "No. The AI identifies potential damages, but user confirmation is required. You remain in control and can confirm, edit, remove, or manually add damages to ensure the final stamp is accurate before submission.",
    },
  ],
};

const pricingPlans = {
  plans: [
    {
      id: "single",
      name: "Drive Log",
      subtitle: "Pre Drive record",
      price: 11.99,
      currency: "USD",
      features: [
        {
          title: "Vehicle Identity Record",
          des: "",
        },
        {
          title: "Vehicle Status and usage Record",
          des: "",
        },
        {
          title: "Geo Timestamp capture ",
          des: "",
        },
        {
          title: "Exterior Condition Assessment",
          des: "",
        },
        {
          title: "Interior Condition Assessment",
          des: "",
        },
        {
          title: "30-Day Interactive Digital Record",
          des: "",
        },
      ],
      features_list: [
        "Real-Time AI Vehicle Body Scanning",
        "Automated Vehicle Data Capture",
        "Departure Condition Report",
        "AI Pre-Trip Risk & Care Recommendations",
      ],

      description: "Document the vehicle’s condition at departure",
      value: "Single",
    },
    {
      id: "dual",
      name: "Drive Audit",
      subtitle: "post drive record",
      price: 24.99,
      currency: "USD",
      features: [
        {
          title: "Includes all Origin Stamp features, plus:",
          des: "",
        },
        {
          title: "Vehicle Identity Verification",
          des: "",
        },
        {
          title: "Vehicle Status & Usage Impact",
          des: "",
        },
        {
          title: "Return Location & Date Proof",
          des: "",
        },
        {
          title: "Exterior Impact Assessment",
          des: "",
        },
        {
          title: "Interior Impact Assessment",
          des: "",
        },
      ],
      features_list: [
        "Includes all Single Inspection features, plus:",
        "Return Inspection Report",
        "VIN Consistency Verification",
        "AI Post-Trip Insights & Liability Signals",
      ],
      description: "Verify the vehicle’s condition before and after each trip ",
      value: "Dual",
    },
    {
      id: "trip_audit_plus",
      name: "Drive Invoice",
      subtitle: "pre/post drive",
      price: 49.99,
      currency: "USD",
      features: [
        {
          title: "Includes all ImpactStamp features, plus:",
          des: "",
        },
        {
          title: "Drive Cost customisation",
          des: "",
        },
        {
          title: "Vehicle Usage Calculation",
          des: "",
        },
        {
          title: "Late Return Penalty Calculation",
          des: "",
        },
        {
          title: "Post-Drive Damage & Repair Cost Calculation",
          des: "",
        },
      ],
      description:
        "Generate detailed invoices for each trip with custom charges",
      note: "",
      value: "Invoice",
    },
  ],
  prices: {
    Single: {
      "7": 11.99,
      "15": 19.99,
      "30": 11.99,
    },
    Dual: {
      "7": 24.99,
      "15": 29.99,
      "30": 24.99,
    },
    Invoice: {
      "7": 49.99,
      "15": 44.99,
      "30": 49.99,
    },
  } as const,
};
export { faqData, blogs_data, pricingPlans };
